var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { createPopper, } from '@popperjs/core';
import { Transition } from 'react-transition-group';
import { useResponsiveProps, } from '@core-front/helper';
import PropsChecker from '@core-front/props-checker';
import { useTheme } from '@core-front/theme-provider';
const DropdownCore = (props) => {
    const innerComponent = props.button.responsive ? React.createElement(DropdownResponsiveCore, Object.assign({}, props, { buttonResponsive: props.button.responsive })) : React.createElement(DropdownCoreInner, Object.assign({}, props));
    return (React.createElement(PropsChecker, { componentName: "Dropdown", componentProps: props, defaultValueName: "defaultIsOpen", valueName: "isOpen", onChangeNames: "onToggle" }, innerComponent));
};
export default DropdownCore;
const DropdownResponsiveCore = (props) => {
    const { buttonResponsive: responsive, button } = props, rest = __rest(props, ["buttonResponsive", "button"]);
    const { breakPoints } = useTheme();
    const responsiveProps = useResponsiveProps({ breakPoints, responsive });
    return React.createElement(DropdownCoreInner, Object.assign({}, rest, { button: Object.assign(Object.assign({}, button), responsiveProps) }));
};
export class DropdownCoreInner extends React.Component {
    constructor(props) {
        super(props);
        this.popper = null;
        this.button = null;
        this.element = null;
        this.itemLinks = [];
        this.getZIndex = () => {
            /* istanbul ignore else */
            if (this.button) {
                const inHeader = this.button.closest('.header') !== null;
                const inModal = this.button.closest('.modal') !== null;
                if (inHeader || inModal) {
                    return 30;
                }
            }
            return 19;
        };
        this.enablePopper = () => {
            this.initPopper();
        };
        this.handleClose = () => {
            this.disablePopper();
        };
        this.handleButtonClick = (event) => {
            event.preventDefault();
            if (!this.isOpenControlled()) {
                this.setState((prevState) => {
                    return {
                        isOpen: !prevState.isOpen,
                    };
                });
            }
            if (this.props.onToggle) {
                this.props.onToggle(!this.isOpen);
            }
            if (this.props.onClose && this.isOpen) {
                this.props.onClose();
            }
        };
        this.onKeyDown = (event) => {
            var _a;
            switch (event.key) {
                case 'Escape':
                case 'Esc':
                    if (this.isOpen) {
                        event.preventDefault();
                        this.close();
                        (_a = this.button) === null || _a === void 0 ? void 0 : _a.focus();
                    }
                    return;
                case 'Tab': {
                    const prevFocusedItemIndex = this.itemLinks.findIndex((item) => item === document.activeElement);
                    if (event.shiftKey) {
                        if (prevFocusedItemIndex === 0) {
                            this.setState({ focusedElementIndex: -1 });
                        }
                        if (prevFocusedItemIndex > -1) {
                            this.setState({ focusedElementIndex: prevFocusedItemIndex - 1 });
                        }
                    }
                    else {
                        if (document.activeElement === this.button) {
                            this.setState({ focusedElementIndex: 0 });
                        }
                        if (prevFocusedItemIndex > -1) {
                            if (prevFocusedItemIndex === this.itemLinks.length - 1) {
                                this.close();
                            }
                            else {
                                this.setState({ focusedElementIndex: prevFocusedItemIndex + 1 });
                            }
                        }
                    }
                }
            }
        };
        this.buttonRef = (el) => {
            this.button = el;
            if (this.props.button.buttonRef) {
                this.props.button.buttonRef(el);
            }
        };
        this.handleOpen = this.handleOpen.bind(this);
        this.onClickOutside = this.onClickOutside.bind(this);
        this.disablePopper = this.disablePopper.bind(this);
        this.state = {
            isMounted: false,
            isOpen: props.defaultIsOpen || false,
            focusedElementIndex: -1,
        };
    }
    componentDidMount() {
        document.addEventListener('mousedown', this.onClickOutside);
        this.setState({
            isMounted: true,
        }, this.enablePopper);
    }
    componentWillUnmount() {
        this.disablePopper();
        document.removeEventListener('mousedown', this.onClickOutside);
    }
    componentDidUpdate(prevProps, prevState) {
        if ((this.props.isOpen && !prevProps.isOpen) || (this.state.isOpen && !prevState.isOpen)) {
            this.handleOpen();
        }
        else if ((!this.props.isOpen && prevProps.isOpen) || (!this.state.isOpen && prevState.isOpen)) {
            this.handleClose();
        }
    }
    isOpenControlled(isOpen = this.props.isOpen) {
        return !!this.props.onToggle && typeof isOpen !== 'undefined';
    }
    get isOpen() {
        return this.isOpenControlled(this.props.isOpen) ? this.props.isOpen : this.state.isOpen;
    }
    disablePopper() {
        if (this.popper) {
            this.popper.destroy();
            this.popper = null;
        }
    }
    initPopper() {
        if (this.isOpen && this.props.items && this.element && this.button && !this.popper) {
            this.popper = createPopper(this.button, this.element, {
                modifiers: [
                    { name: 'applyStyles', enabled: false },
                    { name: 'flip', enabled: false },
                    {
                        name: 'updateState',
                        enabled: true,
                        phase: 'write',
                        requires: ['computeStyles'],
                        fn: ({ state }) => {
                            this.setState({
                                popperStyle: Object.assign(Object.assign({}, state.styles.popper), { zIndex: this.getZIndex() }),
                            });
                        },
                    },
                ],
                placement: this.props.align === 'end' ? 'bottom-end' : 'bottom-start',
            });
        }
    }
    close() {
        if (this.props.onClose && this.isOpen) {
            this.props.onClose();
        }
        if (this.props.onToggle && this.isOpen) {
            this.props.onToggle(false);
        }
        if (!this.isOpenControlled()) {
            this.setState({
                isOpen: false,
            });
        }
        this.setState({ focusedElementIndex: -1 });
    }
    onClickOutside(event) {
        const { outsideClickCloseFilter } = this.props;
        const clickedOnTrigger = this.button && event.target instanceof Element && this.button.contains(event.target);
        const clickedOnDropdown = this.element && event.target instanceof Node && this.element.contains(event.target);
        const clickedOnOutsideTrigger = event.target instanceof Element && outsideClickCloseFilter && outsideClickCloseFilter(event.target);
        if (clickedOnTrigger || clickedOnOutsideTrigger || clickedOnDropdown) {
            return;
        }
        this.close();
    }
    BEM(state) {
        const classArray = ['dropdown', `is-${state}`, `dropdown--width-${this.props.width}`];
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    handleOpen() {
        this.enablePopper();
    }
    get items() {
        const items = this.props.items || [];
        let globalIndex = 0;
        return items.map((item) => {
            globalIndex++;
            const currentIndex = globalIndex - 1;
            return Object.assign(Object.assign({}, item), { isFocused: this.state.focusedElementIndex === currentIndex, tabIndex: -1 });
        });
    }
    get hiddenItems() {
        const items = this.props.items || [];
        let globalIndex = 0;
        return items.map((item) => {
            globalIndex++;
            const currentIndex = globalIndex - 1;
            return Object.assign(Object.assign({}, item), { id: item.id ? `${item.id}-hidden` : undefined, elementRef: (el) => el && (this.itemLinks[currentIndex] = el), tabIndex: this.isOpen ? undefined : -1 });
        });
    }
    renderDropdown() {
        const { Suggestion } = this.props.components;
        const content = (state) => (React.createElement("div", { ref: (el) => this.element = el, className: this.BEM(state), style: this.state.popperStyle, "aria-hidden": true },
            React.createElement(Suggestion, { items: this.items, className: "dropdown__suggestion" })));
        return (React.createElement(Transition, { in: this.isOpen, timeout: { enter: 10, exit: 100 }, mountOnEnter: true, unmountOnExit: true, onExited: this.disablePopper }, content));
    }
    renderHiddenDropdown() {
        const { Suggestion } = this.props.components;
        return (React.createElement("div", { className: "dropdown is-hidden", onKeyDown: this.onKeyDown, "aria-hidden": !this.isOpen },
            React.createElement(Suggestion, { id: this.props.id, items: this.hiddenItems })));
    }
    renderButtonOrCollapseToggle(button) {
        const { Button, CollapseToggle } = this.props.components;
        if (button.iconRight && button.iconRight === '#arrow-down') {
            return (React.createElement(CollapseToggle, Object.assign({}, button, { onClick: this.handleButtonClick, buttonRef: this.buttonRef, isActive: this.isOpen, "aria-expanded": this.isOpen, "aria-controls": this.props.id, onKeyDown: this.onKeyDown })));
        }
        return (React.createElement(Button, Object.assign({}, button, { onClick: this.handleButtonClick, buttonRef: this.buttonRef, isActive: this.isOpen, "aria-expanded": this.isOpen, "aria-controls": this.props.id, onKeyDown: this.onKeyDown })));
    }
    render() {
        return (React.createElement(React.Fragment, null,
            this.renderButtonOrCollapseToggle(this.props.button),
            this.renderHiddenDropdown(),
            this.state.isMounted ? ReactDOM.createPortal(this.renderDropdown(), this.props.portalContainer || document.body) : this.renderDropdown()));
    }
}
DropdownCoreInner.defaultProps = {
    align: 'start',
    width: 'default',
};
